import { Link, useLocation } from 'react-router-dom'

// Paginador reutilizable. Recibe page/totalPages y un callback para cambiar
// de página; o bien usa enlaces cuando se pasa basePath.
export default function Pager({ page, totalPages, onPage, basePath }) {
  const location = useLocation()
  if (!totalPages || totalPages <= 1) return null

  const pages = []
  for (let i = 1; i <= totalPages; i++) pages.push(i)

  // Si no hay callback, construimos enlaces preservando el query actual
  const toHref = (p) => {
    const sp = new URLSearchParams(location.search)
    sp.set('page', String(p))
    return `${basePath || location.pathname}?${sp.toString()}`
  }

  return (
    <nav className="pager" aria-label="Seitennummerierung">
      {onPage ? (
        <>
          <button disabled={page <= 1} onClick={() => onPage(page - 1)}>‹ Zurück</button>
          <span className="pager-info">Seite {page} / {totalPages}</span>
          <button disabled={page >= totalPages} onClick={() => onPage(page + 1)}>Weiter ›</button>
        </>
      ) : (
        <>
          <Link className={page <= 1 ? 'is-disabled' : ''} to={toHref(page - 1)} aria-disabled={page <= 1}>‹ Zurück</Link>
          <span className="pager-info">Seite {page} / {totalPages}</span>
          <Link className={page >= totalPages ? 'is-disabled' : ''} to={toHref(page + 1)} aria-disabled={page >= totalPages}>Weiter ›</Link>
        </>
      )}
    </nav>
  )
}
